import { FilterOptionList, VisibleEnumSelect } from '@yeshuman/sdk'
import type { FilterDefinition, FilterOption } from '@yeshuman/sdk'
import { Pill } from 'lucide-react'

import type { TherapeuticFilters, TherapeuticTypeFilter } from '../hooks/use-therapeutics'

export const THERAPEUTIC_TYPE_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
  { value: 'medication', label: 'Medication' },
  { value: 'supplement', label: 'Supplement' },
  { value: 'therapy_session', label: 'Therapy session' },
]

export function getHealthTherapeuticFilterDefinitions(): FilterDefinition<TherapeuticFilters, undefined>[] {
  return [
    {
      key: 'therapeutic_type',
      label: 'Type',
      icon: Pill,
      displayValue: (filters) =>
        THERAPEUTIC_TYPE_OPTIONS.find((o) => o.value === filters.therapeutic_type)?.label ?? 'All',
      isNonDefault: (filters) => Boolean(filters.therapeutic_type),
      reset: (filters) => ({ ...filters, therapeutic_type: undefined }),
      renderField: ({ filters, onChange }) => (
        <VisibleEnumSelect
          value={filters.therapeutic_type ?? 'all'}
          options={THERAPEUTIC_TYPE_OPTIONS}
          onValueChange={(v) =>
            onChange({
              ...filters,
              therapeutic_type: v === 'all' ? undefined : (v as TherapeuticTypeFilter),
            })
          }
        />
      ),
      renderPopover: ({ filters, onChange }) => (
        <FilterOptionList
          type="single"
          options={THERAPEUTIC_TYPE_OPTIONS}
          value={filters.therapeutic_type ?? 'all'}
          onValueChange={(v) =>
            onChange({
              ...filters,
              therapeutic_type: v === 'all' ? undefined : (v as TherapeuticTypeFilter),
            })
          }
        />
      ),
    },
  ]
}
